import { Grid } from '@mui/material';
import { CfDataGridProps } from '../../../CfDataGridProps';
import { CfDataGridCard } from '../card/CfDataGridCard';
import { CfDataGridCardRowBaseProps } from './common';

export function CfDataGridCardRow<TItem>(props: {
  baseProps: CfDataGridCardRowBaseProps<TItem>;
  items: (TItem | undefined)[];
  dataGridProps: CfDataGridProps<TItem>;
}): JSX.Element {
  const { baseProps, items, dataGridProps } = props;
  return (
    <Grid container columnSpacing={2} sx={{ paddingTop: 2 }}>
      {items.map((item: TItem | undefined, index: number) => (
        <CfDataGridCard
          key={item ? dataGridProps.selectId(item) : index}
          item={item}
          cardViewDefinition={baseProps.cardViewDefinition}
          index={baseProps.rowIndex + index}
          onItemClicked={dataGridProps.onItemClicked}
          hoverStyle={dataGridProps.hoverStyle}
          cursorStyle={dataGridProps.cursorStyle}
          setNavigableElement={baseProps.setNavigableElement}
          recomputeRowHeights={baseProps.recomputeRowHeights}
          recomputeRowHeight={baseProps.recomputeRowHeight}
          orientation={baseProps.orientation}
        />
      ))}
    </Grid>
  );
}
